var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 815.0813648293963 811.9711286089239",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0l0 -811.9711z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l815.08136 0l0 811.9711l-815.08136 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9900",
    d: "m812.76904 405.98557l-163.52649 58.15387l0 -116.30774zm-118.71692 -286.54898l-74.488525 156.76694l-82.240845 -82.240906zm-286.51144 -118.679375l58.15387 163.52647l-116.30774 0zm-286.54895 118.679375l156.76692 74.526024l-82.24089 82.240906zm-118.67938 286.54898l163.52649 -58.15387l0 116.30774zm118.67938 286.51144l74.52603 -156.72943l82.24089 82.240906zm286.54895 118.71692l-58.15387 -163.52649l116.30774 0zm286.51144 -118.71692l-156.72937 -74.488525l82.240845 -82.240906zm-489.1256 -286.51144l0 0c0 -111.90073 90.71344 -202.61418 202.61417 -202.61418c111.90073 0 202.61417 90.713455 202.61417 202.61418c0 111.90073 -90.71344 202.61417 -202.61417 202.61417c-111.90073 0 -202.61417 -90.71344 -202.61417 -202.61417z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m812.76904 405.98557l-163.52649 58.15387l0 -116.30774zm-118.71692 -286.54898l-74.488525 156.76694l-82.240845 -82.240906zm-286.51144 -118.679375l58.15387 163.52647l-116.30774 0zm-286.54895 118.679375l156.76692 74.526024l-82.24089 82.240906zm-118.67938 286.54898l163.52649 -58.15387l0 116.30774zm118.67938 286.51144l74.52603 -156.72943l82.24089 82.240906zm286.54895 118.71692l-58.15387 -163.52649l116.30774 0zm286.51144 -118.71692l-156.72937 -74.488525l82.240845 -82.240906zm-489.1256 -286.51144l0 0c0 -111.90073 90.71344 -202.61418 202.61417 -202.61418c111.90073 0 202.61417 90.713455 202.61417 202.61418c0 111.90073 -90.71344 202.61417 -202.61417 202.61417c-111.90073 0 -202.61417 -90.71344 -202.61417 -202.61417z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.206c97dceae9ae9adb97c9ce28255259.svg";
export { ForwardRef as ReactComponent };